import React from 'react';
import PropTypes from 'prop-types';

import { Tab, Tabs } from 'react-bootstrap-5';

import PlaybooksConfig from 'bundles/apex/playbooks/config';

export default function ApexSettings({ playbooksConfigProps }) {
  if (!playbooksConfigProps?.showListingPlaybooks) {
    return <PlaybooksConfig {...playbooksConfigProps} playbookRecordType="deal" />;
  }

  return (
    <Tabs defaultActiveKey="dealPlaybooks" id="apex-settings" unmountOnExit>
      <Tab eventKey="dealPlaybooks" title="Deals">
        <PlaybooksConfig {...playbooksConfigProps} playbookRecordType="deal" />
      </Tab>
      <Tab eventKey="listingPlaybooks" title="Listings">
        <PlaybooksConfig {...playbooksConfigProps} playbookRecordType="listing"/>
      </Tab>
    </Tabs>
  );
}

ApexSettings.propTypes = {
  playbooksConfigProps: PropTypes.shape({
    showListingPlaybooks: PropTypes.bool,
  }).isRequired,
};
